module.exports = __webpack_public_path__ + "static/img/1_05.4bc753a.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/1_05.png
// module id = 7zw/
// module chunks = 6